import { render } from "./NcrmPrivacyDoiResendPanel.vue?vue&type=template&id=56eb0e02"
import script from "./NcrmPrivacyDoiResendPanel.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyDoiResendPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__